import { toast } from "sonner";
import customFetch from "../util/config/axiosConfig";
import { FormField, FormFieldsResponse } from "../types/Query";

const queryFieldControllerApis = {
  // dynamic forms
  getFormFields: async (
    schoolBranchCode: string,
  ): Promise<FormFieldsResponse | undefined> => {
    try {
      const response = await customFetch.get(
        `/api/query-field/get/${schoolBranchCode}`,
      );
      return response.data as FormFieldsResponse;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load form fields");
      return undefined;
    }
  },

  // update
  updateField: async (id: number, data: FormField) => {
    try {
      const res = await customFetch.put(`/api/query-field/update/${id}`, data);
      toast.success("Field updated successfully!");
      return res.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to update field");
      throw err;
    }
  },

  // post
  addCustomField: async (schoolBranchCode: string, data: FormField) => {
    try {
      const res = await customFetch.put(
        `/api/query-field/add-custom/${schoolBranchCode}`,
        data,
      );
      toast.success("Custom field added successfully!");
      return res.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to add custom field");
      throw err;
    }
  },

  deleteField: async (id: number) => {
    try {
      const response = await customFetch.delete(`/api/v1/query-field/delete/${id}`);
      toast.success("Question deleted successfully");
      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete question");
      return undefined;
    }
  },
};

export default queryFieldControllerApis;
